<template>
  <div class="content">
    <title-bar :title="$lang.setPassWord_title"></title-bar>
    <div class="senha-cont">
      <p v-if="initReadError" class="set-password-read-error">
        {{ initReadError }}
      </p>
      <p v-if="privacyPasswdSetted === 'no'" class="primary-color3 t-c m-t-10">
        {{ $lang.setPassWord_txt }}
      </p>
      <p class="m-t-15">{{ $lang.setPassWord_txt2 }}</p>

      <div v-if="privacyPasswdSetted === 'yes'" class="m-t-20">
        <p class="m-b-5">{{ $lang.setPassWord_txt3 }}</p>
        <van-password-input
          :value="passWord"
          :error-info="errorInfo"
          :focused="showKeyboard"
          @focus="showKeyboardFun()"
        />
        <van-number-keyboard
          v-model="passWord"
          :show="showKeyboard"
          :close-button-text="$lang.Confirmar"
          @blur="showKeyboard = false"
        />
      </div>

      <div class="m-t-10">
        <p class="m-b-5">{{ $lang.setPassWord_txt4 }}</p>
        <van-password-input
          :value="passWord2"
          :error-info="errorInfo2"
          :focused="showKeyboard2"
          @focus="showKeyboardFun2()"
        />
        <van-number-keyboard
          v-model="passWord2"
          :show="showKeyboard2"
          :close-button-text="$lang.Confirmar"
          @blur="showKeyboard2 = false"
        />
      </div>
      <p class="m-t-15 info-color">
        {{ $lang.setPassWord_txt5 }}
      </p>
      <van-button
        size="large"
        class="custom-button m-t-20"
        :disabled="submitting"
        @click="submit"
      >
        {{ $lang.Confirmar }}
      </van-button>
    </div>
  </div>
</template>
<script>
import { ChangePrivacyPwd, Init } from '@/api/common'
import md5 from 'md5'
import { contentOf, failMessage, handleNeedLogin, isOk, isSafeWriteSuccess } from './safeFlow'
import { safeGetStorageItem, safeLocalStorage } from '@/utils/safeStorage'
import { hasBankCard } from '@/views/layout/mineNavigation'

function requestErrorPayload(error) {
  if (!error || typeof error !== 'object') return error
  if (error.response && typeof error.response === 'object') {
    if (error.response.data !== undefined) return error.response.data
    if (error.response.body !== undefined) return error.response.body
  }
  return error instanceof Error ? null : error
}

function getLocalStorage() {
  try {
    if (typeof safeLocalStorage === 'function') return safeLocalStorage()
  } catch (e) { return null }
  return null
}

export default {
  name: 'SetPassWord',
  components: {},
  data() {
    return {
      passWord: '',
      passWord2: '',
      errorInfo: '',
      errorInfo2: '',
      showKeyboard: false,
      showKeyboard2: false,
      privacyPasswdSetted: '',
      profile: {},
      submitting: false,
      initReadError: ''
    }
  },
  watch: {
    passWord(v) {
      if (v.length === 6) {
        this.showKeyboard = false
      }
      // 确保输入值不超过6位
      if (v.length > 6) {
        v = v.slice(0, 6)
      }
      this.passWord = v
    },
    passWord2(v) {
      if (v.length === 6) {
        // this.errorInfo2 = ''
        this.showKeyboard2 = false
      }
      // 确保输入值不超过6位
      if (v.length > 6) {
        v = v.slice(0, 6)
      }
      this.passWord2 = v
    }
  },
  mounted() {
    if (!this.ensureLogin()) return
    this.Init()
  },
  methods: {
    getToken() {
      return safeGetStorageItem(getLocalStorage(), 'token')
    },
    ensureLogin() {
      if (this.getToken()) return true
      if (this.$bus) this.$bus.$emit('openLogin')
      this.$jumpTo('/home', {}, { replace: true })
      return false
    },
    showRequestError(data, fallback = '提现密码请求失败，请稍后重试。') {
      const source = requestErrorPayload(data)
      if (handleNeedLogin(this, source)) return ''
      const message = failMessage(source, fallback)
      this.$toast({
        message,
        icon: 'cross'
      })
      return message
    },
    async Init() {
      if (!this.ensureLogin()) return
      try {
        const data = await Init()
        if (isOk(data)) {
          const content = contentOf(data)
          this.initReadError = ''
          this.profile = content
          this.privacyPasswdSetted = content.privacyPasswdSetted === 'yes' ? 'yes' : 'no'
        } else {
          const message = this.showRequestError(data, '提现密码资料读取失败，已保留已加载资料。')
          if (message) this.initReadError = message
        }
      } catch (e) {
        const message = this.showRequestError(e, '提现密码资料读取失败，已保留已加载资料。')
        if (message) this.initReadError = message
      }
    },
    async ChangePrivacyPwd(params) {
      try {
        const data = await ChangePrivacyPwd(params)
        if (isSafeWriteSuccess(data)) {
          const source = this.$route.query.from
          if (source === 'withdraw') {
            this.$jumpTo(
              '/bankAdd',
              { from: 'withdraw', tab: hasBankCard(this.profile) ? 'withdraw' : 'bank' },
              { replace: true }
            )
          } else if (source === 'recharge') {
            this.$jumpTo('/bankAdd', { from: 'recharge' }, { replace: true })
          } else {
            this.$router.go(-1)
          }
        } else {
          this.showRequestError(data)
        }
      } catch (e) {
        this.showRequestError(e)
      }
    },
    showKeyboardFun() {
      this.showKeyboard = true
      this.showKeyboard2 = false
    },
    showKeyboardFun2() {
      this.showKeyboard2 = true
      this.showKeyboard = false
    },
    async submit() {
      if (this.submitting) return
      if (!this.ensureLogin()) return
      this.errorInfo = ''
      this.errorInfo2 = ''

      if (this.privacyPasswdSetted === 'yes' && this.passWord.length < 6) {
        this.errorInfo = this.$lang.setPassWord_txt6
      }

      if (this.passWord2.length < 6) {
        this.errorInfo2 = this.$lang.setPassWord_txt6
      }

      if (
        this.privacyPasswdSetted === 'yes' &&
        this.passWord.length > 0 &&
        this.passWord === this.passWord2
      ) {
        this.errorInfo2 = this.$lang.setPassWord_txt7
      }
      if (this.errorInfo || this.errorInfo2) return

      this.submitting = true
      try {
        if (
          this.privacyPasswdSetted === 'yes' &&
          this.errorInfo === '' &&
          this.errorInfo2 === ''
        ) {
          await this.ChangePrivacyPwd({
            newPrivacyPwd: md5(this.passWord2),
            oldPrivacyPwd: md5(this.passWord)
          })
        } else if (this.privacyPasswdSetted === 'no' && this.errorInfo2 === '') {
          await this.ChangePrivacyPwd({
            newPrivacyPwd: md5(this.passWord2)
          })
        }
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
.senha-cont {
  padding: 10px;
}

.set-password-read-error {
  margin: 10px 0;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(220, 38, 38, 0.12);
  border: 1px solid rgba(220, 38, 38, 0.28);
  color: var(--vk-danger);
  font-size: var(--vk-fs-xs);
  line-height: 18px;
}
</style>
